import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parseString } from 'xml2js';
import { contains, forEachObjIndexed, toLower, filter, head } from 'ramda';

import { mapIndexed } from 'utils/ramdaAdditions';
import { systemFields, hiddenFields, isArrayField } from 'constants/xmlFields';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DocumentFieldText } from './DocumentFieldText';
import EmptyDocument from './EmptyDocument';
import InterviewRecruiter from '../xmlDocuments/InterviewRecruiter';
import InterviewLineManager from '../xmlDocuments/interviewLineManager';
import VerificateRecomendation from '../xmlDocuments/VerificateRecomendation';
import LandingResponse from '../xmlDocuments/LandingResponse';
import Marketing from '../xmlDocuments/Marketing';
import { INTERVIEW_RECRUTER, INTERVIEW_CONTACT, VERIFICATE_RECOMENDATION, RESPONSE, MARKETING } from 'constants/xmlDocumentTypes';

const documentComponents = {
    [INTERVIEW_RECRUTER]: InterviewRecruiter,
    [INTERVIEW_CONTACT]: InterviewLineManager,
    [VERIFICATE_RECOMENDATION]: VerificateRecomendation,
    [RESPONSE]: LandingResponse,
    [MARKETING]: Marketing,
};

const parseArray = (array) => {
    let result = [];

    forEachObjIndexed((object) => {
        let resultObject = {};

        forEachObjIndexed((value, key) => {
            resultObject[key] = head(value);
        }, object)

        result.push(resultObject);
    }, array);

    return result;
}

export default class DocumentXMLForm extends Component {
    state = {
        xml: null
    }

    static propTypes = {
        document: PropTypes.object.isRequired,
        body: PropTypes.object.isRequired
    }

    composeValues = (item, objectKey, prevObjectKey) => {
        forEachObjIndexed((field, key) => {
            if (typeof field === 'string') {
                const inHiddenFields = hiddenFields[this.xmlType] && contains(toLower(`${prevObjectKey}.${objectKey}`), hiddenFields[this.xmlType]);
                if (inHiddenFields) {
                    return;
                }
                this.xml.push({
                    id: objectKey,
                    key: `xml.${this.xmlType}.${objectKey}`,
                    value: field
                });
            } else if (Array.isArray(field) && isArrayField[this.xmlType] && contains(prevObjectKey, isArrayField[this.xmlType])) {
                this.xml.push({
                    id: prevObjectKey,
                    key: `xml.${this.xmlType}.${prevObjectKey}`,
                    value: parseArray(field),
                });
            } else {
                this.composeValues(field, key, typeof field === 'object' && !prevObjectKey ? key : prevObjectKey);
            }
        }, item);
    }

    componentDidMount() {
        const xmlObject = this.props.body;
        this.xmlType = this.props.document.xmlType;

        parseString(xmlObject.body, (err, { xmlbody }) => {
            if (!xmlbody) return;

            this.xml = [];
            this.composeValues(xmlbody);
            this.setState({
                xml: this.xml
            });
        });
    }

    filterSustemFields = filter((item) => !contains(toLower(item.id), systemFields))

    renderFields(xml) {
        return mapIndexed((value, index) => (
            <DefinitionField
                key={index}
                translate={value.key}
                text={<DocumentFieldText name={value.key} value={value.value} />}
            />
        ), this.filterSustemFields(xml));
    }

    renderComponent(xml) {
        const DocumentComponent = documentComponents[this.xmlType];
        return DocumentComponent ? <DocumentComponent xml={xml} /> : this.renderFields(xml);
    }

    render() {
        const { xml } = this.state;

        return (
            <div className="preview-paddings">
                { xml ? this.renderComponent(xml) : <EmptyDocument/> }
            </div>
        );
    }
}
